import React from "react";

function Terms() {
  return (
    <div>
      {/* Hero Section */}
      <div className="container-fluid bg-primary py-5 mb-5 hero-header">
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-3 text-white animated slideInDown">
                Terms & Conditions
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* Terms Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="text-center mb-5">
            {/* <h1 className="mb-5">Terms & Conditions</h1> */}
            <p className="text-muted">Effective Date: 01.04.2026</p>
          </div>

          <div className="row">
            <div className="col-lg-12">

              <h5 className="mt-4">Introduction</h5>
              <p>
                Welcome to Ceylonsman. By accessing our website and using our
                services, you agree to comply with and be bound by these Terms
                & Conditions.
              </p>

              <h5 className="mt-4">Services Provided</h5>
              <p>
                We act as an intermediary between you and travel service
                providers such as airlines, hotels, and transportation
                companies. We do not own or operate these services.
              </p>

              <h5 className="mt-4">Booking and Payment</h5>
              <p>
                All bookings are subject to availability and confirmation.
                Prices may change without notice. Payment must be completed
                before confirmation.
              </p>

              <h5 className="mt-4">Cancellations and Refunds</h5>
              <p>
                Cancellation policies vary by provider. Refunds will follow
                provider policies and may include fees. Ceylonsman service
                fees are non-refundable.
              </p>

              <h5 className="mt-4">Travel Documents</h5>
              <p>
                You are responsible for valid passports, visas, and required
                travel documents.
              </p>

              <h5 className="mt-4">Liability Disclaimer</h5>
              <p>
                We do not guarantee all information is error-free and are not
                responsible for third-party changes.
              </p>

              <h5 className="mt-4">User Responsibilities</h5>
              <p>
                You must provide accurate information and comply with
                applicable laws.
              </p>

              <h5 className="mt-4">User Conduct</h5>
              <ul>
                <li>Use the platform lawfully</li>
                <li>No harmful or illegal content</li>
                <li>No unauthorized system access</li>
                <li>No interference with website functionality</li>
              </ul>

              <h5 className="mt-4">Third-Party Liability</h5>
              <p>
                We are not responsible for third-party services or disputes.
              </p>

              <h5 className="mt-4">Intellectual Property</h5>
              <p>
                All website content belongs to Ceylonsman and cannot be reused
                without permission.
              </p>

              <h5 className="mt-4">Privacy</h5>
              <p>
                Your use of our website is also governed by our Privacy Policy.
              </p>

              <h5 className="mt-4">Governing Law</h5>
              <p>
                These terms are governed by the laws of Sri Lanka.
              </p>

              <h5 className="mt-4">Contact Us</h5>
              <p>
                Email: info@ceylonsman.com <br />
                Address: Ceylonsman (Private) Limited, No: 199/D, Kaduwela Road,
                Oruwala, Athurugiriya (10150), Sri Lanka
              </p>

            </div>
          </div>
        </div>
      </div>
      {/* Terms End */}
    </div>
  );
}

export default Terms;